import * as THREE from 'three';

const cache = THREE.Cache;
//cache.enabled = true;

const textureLoader = new THREE.TextureLoader();

export function textureProgressLoader(url, onLoad, onProgress, onError) {
    const cached = cache.get(url);
    
    // Если текстура уже в кэше, сразу возвращаем её
    // if (cached) {
    //     onLoad(cached);
    //     return;
    // }

    // Используем FileLoader для загрузки Blob
    const fileLoader = new THREE.FileLoader();
    fileLoader.setResponseType('blob');
    
    fileLoader.load(
        url,
        (blob) => {
            //console.log({url})
            // Создаем Object URL из Blob
            const objUrl = URL.createObjectURL(blob);

            //console.log({objUrl})
            
            // Загружаем текстуру через Object URL
            textureLoader.load(
                objUrl,
                (texture) => {
                    //console.log({texture})
                    // Добавляем в кэш исходный URL → текстуру
                    cache.add(url, texture);
                    URL.revokeObjectURL(objUrl); // Освобождаем ресурсы
                    onLoad(texture);
                },
                undefined,
                (err) => {
                    URL.revokeObjectURL(objUrl);
                    onError(err);
                }
            );
        },
        onProgress,
        (err) => {
            console.error('FileLoader error:', err);
            onError(err);
        }
    );
}